/**
 * Fait : le COMPOSER du fil — le choix du modèle (depuis le catalogue,
 *   jamais un nom en dur), le champ de saisie, Envoyer, et l'entrée vers la
 *   comparaison. Envoyer se désactive pendant une génération : une branche
 *   ne porte qu'une réponse à la fois, l'écran le montre.
 *
 * Ne fait pas : il n'appelle aucune API — le parent (`PageFil`) reçoit la
 *   soumission et agit — et ne calcule rien.
 */

import { ChampLong } from '../gabarits/ChampLong.tsx';
import type { ModeleVu } from './api-fil.ts';

export function ComposerDuFil({
  modeles,
  modeleId,
  texte,
  generationEnCours,
  pret,
  surModele,
  surTexte,
  surEnvoi,
  surComparaison,
}: {
  readonly modeles: readonly ModeleVu[];
  readonly modeleId: string;
  readonly texte: string;
  readonly generationEnCours: boolean;

  /**
   * Le fil est-il prêt à recevoir ? Tant que la branche et le catalogue ne
   * sont pas là, « Envoyer » ne ferait RIEN — en silence. Un clic sans
   * effet ni message est un défaut, pas une attente (traqué à la sortie de
   * la phase 5 : il faisait échouer un témoin une fois sur douze).
   */
  readonly pret: boolean;
  surModele: (id: string) => void;
  surTexte: (texte: string) => void;
  surEnvoi: () => void;
  surComparaison: () => void;
}) {
  return (
    <form
      onSubmit={(evenement) => {
        evenement.preventDefault();
        surEnvoi();
      }}
      data-role="composer"
    >
      <label>
        Modèle{' '}
        <select
          data-role="modeles"
          value={modeleId}
          onChange={(evenement) => {
            surModele(evenement.target.value);
          }}
        >
          {modeles.map((modele) => (
            <option key={modele.id} value={modele.id}>
              {modele.libelle}
            </option>
          ))}
        </select>
      </label>

      <ChampLong
        libelle="Votre message"
        rows={5}
        value={texte}
        onChange={(evenement) => {
          surTexte(evenement.target.value);
        }}
      />

      <div className="barre-de-boutons">
        <button type="submit" data-role="envoyer" disabled={generationEnCours || !pret}>
          Envoyer
        </button>
        <button
          type="button"
          data-role="comparer"
          disabled={!pret || texte.trim() === '' || modeles.length < 2}
          onClick={surComparaison}
        >
          Comparer des modèles
        </button>
      </div>
    </form>
  );
}
